import React, { useState } from 'react';
import { useI18n } from '../i18n/LanguageContext';

const QUOTE = `Muri iyo minsi, 26umumalayika wa Nyagasani abwira Filipo ati « Haguruka ugende werekeje mu majyepfo, unyuremu muhanda umanuka i Yeruzalernu ujya i Gaza, ubu nguhu ukaba utarimo abagenzi. »27Filipo ahera ko aragenda`;

const VIDEO_POSTER = `${process.env.PUBLIC_URL}/assets/community/youth-in-prayer.jpg`;

const PAGES = [
  [
    { id: 'v1', type: 'video', poster: VIDEO_POSTER },
    { id: 't1', type: 'text', quote: QUOTE, author: 'Batete Ange Nadette' },
    { id: 't2', type: 'text', quote: QUOTE, author: 'Batete Ange Nadette' },
  ],
  [
    { id: 't3', type: 'text', quote: QUOTE, author: 'Batete Ange Nadette' },
    { id: 't4', type: 'text', quote: QUOTE, author: 'Batete Ange Nadette' },
    { id: 't5', type: 'text', quote: QUOTE, author: 'Batete Ange Nadette' },
  ],
];

// Initials instead of stock photos, so no stranger's face stands beside a member's words.
function initials(name) {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
}

function PlayIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}

function ChevronLeft() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}
function ChevronRight() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

export default function Testimonials() {
  const { t } = useI18n();
  const [page, setPage] = useState(0);
  const items = PAGES[page];

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-inner">
        <div className="about-eyebrow">
          <span className="about-dot" /> {t('testimonials.eyebrow')}
        </div>
        <h2 className="testimonials-heading">{t('testimonials.title')}</h2>

        <div className="testimonial-grid">
          {items.map((item) =>
            item.type === 'video' ? (
              <div key={item.id} className="testimonial-card testimonial-card--video">
                <img className="testimonial-poster" src={item.poster} alt={t('testimonials.poster_alt')} />
                <button type="button" className="testimonial-play" aria-label={t('testimonials.play')}>
                  <PlayIcon />
                </button>
              </div>
            ) : (
              <article key={item.id} className="testimonial-card testimonial-card--text">
                <span className="testimonial-avatar testimonial-avatar--initials" aria-hidden="true">{initials(item.author)}</span>
                <p className="testimonial-quote">{item.quote}</p>
                <footer className="testimonial-author">~ {item.author}</footer>
              </article>
            )
          )}
        </div>

        <div className="testimonial-pagination" role="navigation" aria-label={t('testimonials.pages')}>
          <button
            type="button"
            className="testimonial-page-btn"
            onClick={() => setPage((p) => Math.max(0, p - 1))}
            disabled={page === 0}
            aria-label={t('testimonials.prev')}
          >
            <ChevronLeft />
          </button>
          {PAGES.map((_, i) => (
            <button
              key={i}
              type="button"
              className={'testimonial-page-num' + (i === page ? ' is-active' : '')}
              onClick={() => setPage(i)}
              aria-current={i === page ? 'page' : undefined}
            >
              {i + 1}
            </button>
          ))}
          <button
            type="button"
            className="testimonial-page-btn"
            onClick={() => setPage((p) => Math.min(PAGES.length - 1, p + 1))}
            disabled={page === PAGES.length - 1}
            aria-label={t('testimonials.next')}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
}
